// extracted by mini-css-extract-plugin
var _1 = "L7y5m";
export { _1 as "singleLineContent" }
